import { create } from "domain";

export enum Method {
  GET = "GET",
  POST = "POST",
  PUT = "PUT",
  DELETE = "DELETE",
}

export const URLs = {
  // PROD_BASE_URL_API: "https://mchic-backend.onrender.com/api/",
  PROD_BASE_URL_API:
    "https://vendora-backend-production-4f7e.up.railway.app/api/",
  DEV_BASE_URL_API: "http://localhost:8000/api/",

  // DEV_BASE_URL_API: "http://192.168.100.204:8000/api/", // For Mobile test
};

export const ROUTES = {
  LOGIN: "auth/login",
  REGISTER: "auth/register",
  FORGET_PASSWORD: "auth/forget-password",
  RESET_PASSWORD: "auth/reset-password",
  GET_ALL_USERS: "auth/getallusers",
  GET_USER_BY_EMAIL: "auth/getuserbyemail/",

  // Common routes
  DELETE: "delete",
  CREATE: "create",
  UPDATE: "update",
  DELETE_BY_ID: "deletebyid",

  // Operation routes
  OPERATIONS: "operations/",
  CREATE_OPERATION: "create",
  UPDATE_OPERATION: "update",
  DELETE_OPERATION: "delete",

  // Product routes
  PRODUCTS: "products/",
  CREATE_PRODUCT: "create",
  DELETE_PRODUCT: "delete",

  // Order routes
  ORDERS: "orders/",
  CREATE_ORDER: "create",
  DELETE_ORDER: "delete",
  UPDATE_ORDER: "update",
  UPDATE_ORDER_STATUS: "update-status/",

  // STORE routes
  STORE: "stores/",
  BY_EMAIL: "byemail/",
  STORE_BY_ID: "byid/",
  BY_SUBDOMAIN: "bysubdomain/",
  CHECK_IF_SUBDOMAIN_EXISTS: "checkifsubdomainexists/",
  CREATE_STORES: "create",
  GET_ENABLED_STORES: "getallstores",
  COUNT_STORES: "count",
  LAST_STORE: "last",
  DELETE_PERMANENTLY: "delete-permanently/",

  // Media routes
  MEDIA: "media/",
  GET_S3_URL: "gets3",

  // Migration Routes
  MIGRATION: "migration/",
  MIGRATION_PRODUCTS: "migrationproduct/",

  // Delivery Company Routes
  DELIVERY_COMPANIES: "delivery/",
  DELETE_FRAGMENT_BY_ID: "delete-fragment/",
  CONNECT: "store-config/",

  // Collection Routes
  COLLECTIONS: "collections/",
  COLLECTION_TYPES: "collection-type/",
  ACTIONS: "actions/",
  GET_BY_COMPANY_ID: "get-by-company-id/",

  // User routes
  USERS: "users/",
  GET_USERS_BY_STORE: "getusersbystore/",
  CREATE_NEW_MEMBER: "create-new-member/",
  UPDATE_MEMBER: "update-member/",
  COUNT_USERS: "count",
  GET_USER_BY_ID: "getuserbyid/",

  // HR routes
  HR: "hr/",
  GET_CONTRACTS_BY_STORE: "get-contracts-by-store/",
  GET_CONTRACTS_BY_USER: "get-contracts-by-user/",
  CREATE_CONTRACT: "create-contract",
  UPDATE_CONTRACT: "update-contract",

  // Pack routes
  PACKS: "packs/",
  CREATE_PACK: "create",
  UPDATE_PACK: "update",

  // Invoice routes
  INVOICES: "invoice/",
  CREATE_INVOICE: "create-invoice",
  GET_INVOICE_BY_ID: "get-by-id/",
  GET_INVOICES_BY_STORE_ID: "get-by-store-id/",

  // Chat
  CHATS: "chat/",
  REALTIME_CHATS: "realtimechat/",
  REALTIME_MESSAGES_BY_CHAT_ID: "realtime-messages-by-chat-id/",
  SEND_MESSAGE: "sendmessage",
  GET_ALL_CHATS: "allchats",
  CREATE_CHAT: "initialize-chat",
  UPDATE_CHAT_STATUS: "update-chat-status",
  UPDATE_CHAT_TITLE: "update-chat-title",

  // Notfications
  NOTIFICATIONS: "notifications/",
  GET_NOTIFICATIONS: "get/",
  GET_ALL_NOTIFICATIONS: "get-all",
  CREATE_NOTIFICATION: "create",
  DELETE_NOTIFICATION: "delete/",


  // Mobile App
  MOBILE_APP: "mobile-app/",
  MOBILE_UPLOAD: "upload/",
  GET_LATEST_VERSION: "get-latest/",
  GET_ALL_VERSIONS: "get-all",
  DELETE_VERSION: "delete/",
};
